import { Image } from '../../state';
import { ImageActionType } from './image-action-type';
import { RedirectingAction } from '../interfaces';

export interface SetImageUploadProgressAction extends RedirectingAction {
  imageKey: string;
  progress: number;
  type: ImageActionType.SetUploadProgress;
}

export const setImageUploadProgress = (
  imageKey: string,
  progress: number,
): SetImageUploadProgressAction => ({
  imageKey,
  progress,
  type: ImageActionType.SetUploadProgress,
});
